import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[appBizGridNotInList]',
    providers: [{
            provide: NG_VALIDATORS,
            useExisting: BizGridNotInListDirective,
            multi: true
        }]
})
export class BizGridNotInListDirective implements Validator {
  @Input() appBizGridNotInList: string[] = [];

  validate(control: AbstractControl<any, any>): ValidationErrors {
    if (Array.isArray(this.appBizGridNotInList)) {
      const valueToCheck: string = control.value;

      if (valueToCheck && this.appBizGridNotInList.findIndex(e => valueToCheck.localeCompare(e) === 0) > 0) {
        return { appBizGridNotInList: true };
      }

      return null;
    }
    return undefined;
  }
}
